import { render, staticRenderFns } from "./YearlyData.vue?vue&type=template&id=731e5342&scoped=true"
import script from "./YearlyData.vue?vue&type=script&lang=js"
export * from "./YearlyData.vue?vue&type=script&lang=js"
import style0 from "./YearlyData.vue?vue&type=style&index=0&id=731e5342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e5342",
  null
  
)

export default component.exports